export default {
  name: 'EventListItemPartialView',

  props: {
    event: {
      type: Object,
      required: true
    },
    regions: {
      type: Array,
      required: true
    },
    statuses: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    }
  },

  computed: {
    status () {
      if (this.event.isLocked) {
        return 'LOCKED'
      } else if (this.event.isConfirmed) {
        return 'CONFIRMED'
      } else {
        return 'IN_PREPARATION'
      }
    },

    region () {
      let matchingRegions = this.regions.filter(region => {
        return region.storeRegionID === this.event.regionId
      })
      if (matchingRegions[0]) {
        return matchingRegions[0]
      } else {
        return null
      }
    },

    regionName () {
      if (this.region) {
        return this.region.name
      } else {
        return ''
      }
    },

    statusName () {
      return this.statuses.reduce((result, status) => {
        return status.value === this.status ? status.text : result
      }, '')
    },

    typeName () {
      return this.types.reduce((result, type) => {
        return type.value === this.event.type ? type.text : result
      }, '')
    }
  },

  methods: {
    copyEvent () {
      this.$emit('copy', this.event)
    },

    deleteEvent () {
      this.$emit('delete', this.event)
    },

    lockEvent () {
      this.$emit('lock', this.event)
    },

    multiCopyEvent () {
      this.$emit('multiCopy', this.event)
    },

    openEvent () {
      if (!this.event.isLocked) {
        this.$emit('edit', this.event)
      } else {
        this.$emit('view', this.event)
      }
    },

    unlockEvent () {
      this.$emit('unlock', this.event)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/EventList/EventListItem.js